import React, {useEffect, useState} from 'react';
import './index.css';
import useWindowScroll from '../hooks/useWindowScroll';
import classnames from 'classnames';
import Link from '../link';
import {useLocation} from 'react-router';
import demoStoreLink from '../../utils/config/demoStoreLink';

export default function GoDemoButton() {
  const scrollTop = useWindowScroll();
  const [isScroll, setIsScroll] = useState(false);
  const location = useLocation().pathname.split('/');
  const [pageType, setPageType] = useState();
  const [demoLink, setDemoLink] = useState('/business/showcase/lip-color');
  useEffect(() => {
    if (scrollTop > 0 && !isScroll) {
      setIsScroll(true);
    }
  }, [scrollTop]);

  useEffect(() => {
    if (location.indexOf('products') !== -1) {
      setPageType(location[location.indexOf('products') + 1]);
      const page = demoStoreLink.filter((d) => d.key === pageType)[0];
      if (page) {
        setDemoLink(page.value);
      }
    }
  }, [location]);

  return (
    <Link
      className={classnames({
        'pf-language': true,
        'go-demo-btn--container': true,
        'go-demo-btn--container--active': isScroll,
      })}
      to={demoLink}
    >
      <div className="go-demo-text">
        <div>TRY-ON</div>
      </div>
    </Link>
  );
}
